import { useQuery } from "@tanstack/react-query";
import { format, formatISO, startOfDay } from "date-fns";
import { getStorage } from "store/local";

import proxy from "api/proxy";

const localDate = new Intl.DateTimeFormat("es-CO", {
  dateStyle: "long",
  timeStyle: "short",
  timeZone: "America/Bogota",
});

async function searchAbsence() {
  // Implement searchAbsence logic here
  const session = await getStorage("ctxSession");
  const model = "staff.shift";
  const today = new Date();
  const fields = [
    "employee.rec_name",
    "shift_kind.code",
    "section.name",
    "enter_timestamp",
  ];
  const order = [["enter_timestamp", "DESC"]];
  const limit = 10;
  const domain = [
    ["attendance", "=", null],
    ["enter_timestamp", ">=", formatISO(startOfDay(today))],
    ["enter_timestamp", "<=", formatISO(today)],
    ["section.chiefs", "=", session?.user_employee],
    ["shift_kind.mode", "=", "work"],
    ["state", "!=", "cancelled"]
  ];
  const { data } = await proxy.search(model, domain, fields, limit, order);
  return data;
}

function Notifications() {
  const { data } = useQuery({
    queryKey: ["searchAbsence"],
    queryFn: searchAbsence,
  });

  return (
    <div className="mx-2 w-full bg-neutral-100 rounded-2xl">
      <h1 className="text-3xl text-center text-neutral-500 my-6 font-bold">
        Inasistencias
      </h1>
      <div className="grid py-2 px-4 rounded-2xl gap-y-2">
        {data &&
          data.map((shift) => (
            <div className="p-3 bg-blue-100 rounded-2xl" key={shift.id}>
              <div className="text-sm text-blue-900">
                {shift["employee."].rec_name}
              </div>
              <div className="text-sm text-neutral-700">
                {shift["section."].name}
              </div>
              <div className="flex justify-between">
                <div className="text-sm text-blue-900">
                  <span className="text-neutral-600">Turno: </span>
                  <span className="text-neutral-900">
                    {shift["shift_kind."].code}
                  </span>
                </div>
                <div className="text-sm">
                  <span className="text-neutral-900">
                    {format(
                      new Date(`${shift.enter_timestamp}Z`),
                      "dd/MMM/yyyy HH:mm a",
                    )}
                  </span>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Notifications;
